module.exports = __webpack_public_path__ + "img/empty-file.92cb8b9d.png";